import React, {useState,useContext, useEffect} from 'react';
import { IsAuthContext } from 'app/App';
import { useTranslate } from 'react-redux-multilingual';
import SelectRh from './AdjustmentStockComp/SelectRh';
import axios from 'axios'
import swal from "sweetalert2";
import {ControlAccess} from "@gull";

const useLoad = (sectionid) => {
    const t = useTranslate()
    const [loading,setLoading]=useState(true)
    const [section,setSection]=useState(false)
    const [restriction,setRestriction]=useState(false)
    
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/section/"+sectionid
            ).then((response) => {
                setSection(response.data)
                let restriction = response.data.restriction.filter(value=>value.action==='stockAdjustment')
                if(restriction.length>0){
                    if(restriction[0].grade.length > 0){
                        setRestriction({
                            go:false,
                            grades: restriction[0].grade.map(value=>value.id)
                        })
                    }
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError = (error.response && error.response.status==403) ? t('forbiddenGeneral') : t('unknowError')
                setLoading(false)
                swal.fire(messageError, "", "error");
            })
            setLoading(false)
        })()
    }, [])

    return [loading,section,restriction,setRestriction]
}


const AdjustmentStockMultiZone = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [loading,section,restriction,setRestriction]=useLoad(props.sectionid)
    const [ajustDatas,setAjustDatas]=useState(false);
    const [valueInputCashier,setValueInputCashier]=useState('')
    const [cashierId,setCashierId]=useState(false) 
    const [memoValue,setMemoValue]=useState('Correction stock avant réassort interne') 
    const [validButton,setValidButton]=useState(false) 
    const [isRestricted,setIsRestricted]=useState(false) 

    const moduleCheck = (props.from=='pos')  ? authParam.modules.find(value=>value.name=='pos') : authParam.modules.find(value=>value.name=='wms')

    useEffect(function () {
        let construct = []
        construct.push({
            zoneid:props.articleInfos.stock_mag.id,
            zone_name:props.articleInfos.stock_mag.name,
            actuel:props.articleInfos.stock_mag.stock,
            action_todo:props.articleInfos.stock_mag.action_todo,
            ajust:0
        })
        props.articleInfos.stock_res.map(value=>
            construct.push({
                zoneid:value.id,
                zone_name:value.name,
                actuel:value.stock,
                action_todo:value.action_todo,
                ajust:0
            })
        )
        setAjustDatas(construct)
    },[])

    const doChangeAjust = (e,index) => {
        let val = e.target.value.replace(/[^\d.]/g, '')
        
        const updated = [...ajustDatas]
        updated[index] = {
            ...updated[index],
            ajust: val
        }
        
        setAjustDatas(updated)
    }

    const sendForm = async () => {
        let data = {
            section:props.sectionid,
            rh:(cashierId) ? cashierId : null,
            ajust_datas:ajustDatas,
            memo:memoValue
        }
        const callapi  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/stock_ajust_multi_zone/"+props.articleInfos.article_id,data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{
                props.setShowModalAjust(false)
                props.generateRestock('generate',props.sectionid)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    const doSendForm = () => {
        setValidButton(true)
        if(restriction && !restriction.go){
            setIsRestricted(true)
        }else{
            sendForm()
        }
    }

    const callback = () =>{
        sendForm()
    }

    if(!ajustDatas || loading) return(<>
        <div className="spinner-border spinner-border-sm"></div>
    </>)
    
    return(<>
        <div className="row">
            <div className="col-12">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h5 className="card-title mb-1">
                            {props.articleInfos.article}
                        </h5>

                        {ajustDatas.map((value,index) => {
                            return(<div key={value.zoneid} className="border rounded p-3 mb-3">
                                <div className="row align-items-center g-3">
                                    <div className="col-12 col-md-6">
                                        <div className="fw-semibold">
                                            {value.zone_name}
                                        </div>
                                        <div className="text-muted small">
                                            {t('actualStock')} : <span className="fw-bold">{value.actuel}</span>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label mb-1">
                                            {(value.action_todo=='add') ?
                                                <span className="text-success">{t('add')}</span>
                                                :
                                                <span className="text-danger">{t('remove')}</span>
                                            }
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={ajustDatas[index].ajust}
                                            onFocus={(e) => e.target.select()}
                                            onChange={(e) => doChangeAjust(e,index)}
                                            disabled={isRestricted}
                                        />
                                    </div>
                                </div>
                            </div>)
                        })}
                        {(moduleCheck.params.staff.active && !moduleCheck.params.stock.params?.no_staff) ? <SelectRh section={section} disabled={isRestricted} setCashierId={setCashierId} valueInputCashier={valueInputCashier} setValueInputCashier={setValueInputCashier}/> : false}
                        <div className="form-group">
                            <label className="d-flex" htmlFor="memo">Memo :</label>
                            <textarea disabled={isRestricted} className="form-control" cols="30" rows="5" value={memoValue} onChange={(e) => setMemoValue(e.target.value)}></textarea>
                        </div>
                        {(((!moduleCheck.params.staff.active || moduleCheck.params.stock.params?.no_staff) || cashierId) && memoValue !== '') &&
                            <button disabled={validButton} className='btn btn-primary' onClick={() => doSendForm()}>
                                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                            </button>
                        }
                        {(isRestricted) && 
                            <div className="row d-flex justify-content-center">
                                <div className="col-8 mt-5">
                                    <ControlAccess section={section} focus={true} restriction={restriction} setRestriction={setRestriction} moduleId={props.sectionid} callback={callback}/>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default AdjustmentStockMultiZone;
